<template>
  <div class="SignUp">
    <div class="container">
      <div class="row mt-5">
        <!-- <div class="col-4 col-3 mt-5"></div> -->
        <div class="col-md-6 offset-md-3 mt-5">
          <div class="login-logo">
            <router-link to="/">
              <img :src="client.logo" class="mb-2" alt="Logo" style="width:80px" />
              <h2>{{client.name}}</h2>
            </router-link>
          </div>

          <div class="card mt-5">
            <div class="card-body bg-light">
              <!--  <div class="alert alert-warning" v-show="false">Your session expired. Please login again.</div> -->
              <h4>Sign up</h4>
              <p class="login-box-msg">Please enter your details.</p>

              <form @submit.prevent="signup">
                <div class="form-group">
                  <label for="name">Name</label>
                  <input type="text" v-model="user.name" class="form-control form-control-lg" placeholder :class="{ 'is-invalid': $v.user.name.$error, 'is-valid': !$v.user.name.$invalid}" />
                  <div class="invalid-feedback">
                    <span v-if="!$v.user.name.required">Name is required.</span>
                    <span v-if="!$v.user.name.minLength">Name must be at least {{ $v.user.name.$params.minLength.min }} letters.</span>
                    <span v-if="!$v.user.name.maxLength">Name must be at most {{ $v.user.name.$params.maxLength.max }} letters.</span>
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label for="name">Email</label>
                  <input v-model="user.email" type="email" class="form-control form-control-lg" placeholder :class="{ 'is-invalid': $v.user.email.$error, 'is-valid': !$v.user.email.$invalid}" />
                  <div class="invalid-feedback">
                    <span v-if="!$v.user.email.required">Email is required.</span>
                    <span v-if="!$v.user.email.email">Email must be valid email address.</span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="phone">Phone number</label>
                  <input type="text" v-model="user.phone" class="form-control form-control-lg" placeholder :class="{ 'is-invalid': $v.user.phone.$error, 'is-valid': !$v.user.phone.$invalid}" />
                  <div class="invalid-feedback">
                    <span v-if="!$v.user.phone.required">Phone is required.</span>
                    <span v-if="!$v.user.phone.numeric">Phone must be numeric.</span>
                    <span v-if="!$v.user.phone.minLength">Phone must be at least {{ $v.user.phone.$params.minLength.min }} digits.</span>
                    <span v-if="!$v.user.phone.maxLength">Phone must be at most {{ $v.user.phone.$params.maxLength.max }} digits.</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <button type="submit" class="btn btn-danger btn-lg" :disabled="isDisabled">{{submitButton}}</button>
                  </div>
                  <div class="col-6 text-right">
                    <span style="font-size:12px">Already have an account?</span>
                    <br />
                    <router-link :to="{name: 'SignIn'}">Sign in</router-link>
                  </div>
                  <!-- /.col -->
                </div>
              </form>
            </div>
            <!-- /.login-card-body -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import crypt from "../helper/crypt";
import auth from "../helper/auth";
import { required, email, numeric, minLength, maxLength, minValue } from "vuelidate/lib/validators";

export default {
  name: "SignUp",
  data() {
    return {
      user: {
        name: "",
        email: "",
        phone: "",
      },
      submitButton: "Sign up",
      isDisabled: false,
      submitted: false,
    };
  },

  methods: {
    signup() {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }
      this.submitted = true;
      this.isDisabled = true;
      this.submitButton = "Processing...";

      let form = new FormData();
      form.append("name", this.user.password);
      form.append("email", this.user.email);
      form.append("phone", this.user.phone);
      form.append("originURL", window.location.origin);
      axios
        .post("/signup", form)
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal("", res.data.message, "success");
            this.user = {};
            this.$v.$reset();
          } else {
            this.$swal("", res.data.message, "error");
          }
          this.isDisabled = false;
          this.submitButton = "Sign up";
        })
        .catch((err) => {
          this.$swal("", "Unable to send request.", "error");
          this.isDisabled = false;
          this.submitButton = "Sign up";
        });
    },
  },

  computed: {
    client() {
      return this.$store.state.client;
    },
  },

  mounted() {
    document.title = "Sign up - Support System";
    this.$store.dispatch("getClient");
  },

  validations: {
    user: {
      name: { required, minLength: minLength(2), maxLength: maxLength(30) },
      email: { required, email },
      phone: { required, numeric, minLength: minLength(11), maxLength: maxLength(11) },
    },
  },
};
</script>




<style  scoped>
/* .Login {
  margin: 0;
  padding: 0;
}
.login-box,
.register-box {
  width: 360px;
}
*/
.login-logo,
.register-logo {
  font-size: 2.1rem;
  font-weight: 300;
  margin-bottom: 0.9rem;
  text-align: center;
}
.login-logo img {
  display: inline-block;
}
.login-logo a {
  color: #444;
}
.login-logo a:hover {
  text-decoration: none;
}
/*
@media (max-width: 576px) {
  .login-box,
  .register-box {
    margin-top: 0;
    width: auto;
  }
}
.login-box {
  margin: 0 !important;
}
.register-logo {
  font-size: 1.4rem;
} */
</style>
